import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import Heading from '../../../../shared/library/typography/heading';
import {ASH, CHARCOAL, FOCUS_BLUE} from '../../../../shared/style/colors';
import {PHONE} from '../../../../shared/style/breakpoints';
import {BASE_TEXT} from '../../../../shared/style/typography';

const Container = glamorous.div({
  ...BASE_TEXT,
  display: 'flex',
  justifyContent: 'space-between',
  margin: '10px 0',
  [PHONE]: {
    alignItems: 'center',
    flexDirection: 'column'
  }
});

const Details = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  [PHONE]: {
    flexDirection: 'column'
  }
});

const Logo = glamorous.img({
  height: 110,
  width: 110,
  marginRight: 25,
  border: `1px solid ${ASH}`,
  [PHONE]: {
    marginRight: 0
  }
});

const MetaData = glamorous.div({
  maxWidth: 500,
  [PHONE]: {
    textAlign: 'center'
  }
});

const ToolWrapper = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  [PHONE]: {
    justifyContent: 'center'
  }
});

const Link = glamorous.a({
  color: CHARCOAL,
  textDecoration: 'none',
  '&:hover': {
    color: FOCUS_BLUE
  }
});

const Header = ({logo, title, website}) => {
  return (
    <Container>
      <Details>
        <a href={website} target="_blank" rel="noopener noreferrer" title={`${title} website`}>
          <Logo src={logo} alt={`${title} logo`} />
        </a>
        <MetaData>
          <ToolWrapper>
            <Heading>
              <Link
                href={website}
                target="_blank"
                rel="noopener noreferrer"
                title={`${title} website`}
              >
                {`${title} Comparisons`}
              </Link>
            </Heading>
          </ToolWrapper>
        </MetaData>
      </Details>
    </Container>
  );
};

Header.propTypes = {
  logo: PropTypes.string,
  title: PropTypes.string,
  website: PropTypes.string
};

export default Header;
